import React from 'react';
import { motion } from 'framer-motion';
import GridBackground from './GridBackground';
import CanvasExperience from './CanvasExperience';

const TeamMemberCard = ({ name, title }) => (
  <motion.div
    className="relative rounded-xl p-8 bg-purple-900/30 backdrop-blur-sm 
               hover:bg-purple-900/40 transition-all duration-300"
    whileHover={{ scale: 1.02 }}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
  >
    <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-blue-500 
                    opacity-0 hover:opacity-10 rounded-xl transition-opacity" />
    <h3 className="text-xl font-bold mb-2 text-white">{name}</h3>
    <p className="text-purple-200">{title}</p>
  </motion.div>
);

const TeamPage = () => {
  const teamMembers = [
    {
      name: "Mark Pavlyukovskyy",
      title: "Adult Summer Camp Counselor"
    },
    {
      name: "Andrew Gregory",
      title: "Local Pokémon League Referee"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-900 via-purple-800 to-purple-900 
                    text-white overflow-hidden relative">
      {/* Background layers */}
      <GridBackground />
      <CanvasExperience />
      
      {/* Main content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 py-24">
        <motion.h1 
          className="text-6xl font-bold mb-16"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <span className="bg-clip-text text-transparent bg-gradient-to-r 
                         from-pink-500 to-purple-500">
            Our Team
          </span>
        </motion.h1>

        <div className="grid md:grid-cols-2 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <TeamMemberCard {...member} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
